/*#__PURE__*/ export default JSON.parse('{"key":"mobileNavBarAvantgarde","type":"root","items":[]}');